import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

const Markdown = ({ children, className }) => (
  <ReactMarkdown
    className={className}
    dir="auto"
    remarkPlugins={[remarkGfm, remarkMath]}
    rehypePlugins={[rehypeKatex]}

    /* Prevents wrapping block elements like <p> inside inline contexts */
    disallowedElements={['p']}
    unwrapDisallowed={true}

    // we curently escape HTML tags (setting `True` would simply remove it)
    skipHtml={false} 

    /* The following is disabled, as it doesn't work (we disable any raw HTML here) */
    // components={{
    //   a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />,
    // }}
  >
    {children}
  </ReactMarkdown>
);

export default Markdown;